import LoadingSpinner from '@carvana/ds-spinner';
import cx from 'classnames';
import { useContext } from 'react';
import DsModal from '@/common/DsModal';
import Spinner from '@/vdp/Spinner';
import { SectionId } from '~/constants/vdp/section';
import { useIsDesktop } from '~/context/common/DeviceContext';
import SpinnerContext from '~/context/vdp/SpinnerContext';
import { useGetIsWIPVehicle } from '~/context/vdp/VehicleContext';
import HeroContent from './HeroContent';
import ImageOverlay from './ImageOverlay';
import SpinnerButtons from './SpinnerButtons';
import UnavailableHeroContent from './UnavailableHeroContent';
import VehicleImage from './VehicleImage';
import { CondensedHeroWrapper, CondensedImageWrapper } from '../Hero.styles';

export default function Hero() {
  const {
    isSpinnerImmersive,
    setShouldOpenSpinnerArgs,
    shouldOpenSpinnerArgs
  } = useContext(SpinnerContext);
  const isDesktop = useIsDesktop();
  const isWIPVehicle = useGetIsWIPVehicle();

  return (
    <div className="sm:col-span-1">
      <CondensedHeroWrapper
        className={cx(SectionId.General, 'relative')}
        data-testid="hero-container"
        id={SectionId.Hero}
      >
        <div className="flex flex-col gap-md">
          <CondensedImageWrapper>
            <ImageOverlay />
            <VehicleImage />
          </CondensedImageWrapper>
          {isWIPVehicle ? null : <SpinnerButtons />}
        </div>
        <HeroContent />
      </CondensedHeroWrapper>
      {!isDesktop && (
        <div className="mt-3xl flex flex-col gap-md bg-background-default px-2xl pb-2xl sm:pb-0">
          <UnavailableHeroContent />
        </div>
      )}
      <Spinner shouldHide={!isSpinnerImmersive} />
      <DsModal
        classes={{
          body: 'flex size-full items-center justify-center',
          container: 'rounded-none size-full'
        }}
        desktopMaxHeight="100%"
        isOpen={Boolean(shouldOpenSpinnerArgs)}
        onClose={() => setShouldOpenSpinnerArgs(undefined)}
      >
        <LoadingSpinner />
      </DsModal>
    </div>
  );
}
